module.exports = __webpack_public_path__ + "img/onboardingUpload.96a78328.svg";